import {
    IMappingProfile,
    IQueryParams,
    IQueryParamsSymbol,
    PFWmsEntities,
} from '@pf/shared-common';
import { createMap, forMember, mapFrom, Mapper } from '@automapper/core';
import {
    entitySymbols,
    withArraySearchFilter,
    withDefaultEntityMetadata,
    withDefaultSearchParamsMetadata,
    withFragmentSearchFilter,
    withMetadata,
    withSearchFilterUnTyped,
} from '@pf/shared-utility';
import {
    PackLineCreate,
    PackLineDto,
    PackLineRead,
    PackLineSearchParams,
} from '../../entities/pack-line.dto';
import {
    CurrencySymbol,
    CustomFieldMetadataMap,
} from '@pf/shared/util-platform';

const symbols = entitySymbols(PFWmsEntities.PackLine);

withDefaultEntityMetadata<PackLineDto>(symbols.dto, {
    packedQuantity: Number,
    status: String,
    packingListDate: String,
    projectLineId: String,
    packLineValue: CurrencySymbol,
    lineNumber: Number,
    packingListId: String,
    bundle: Object,
    projectLineItem: Object,
    customFields: [CustomFieldMetadataMap.symbols.dto],
    weight: Object,
    dimensions: Object,
});

withDefaultEntityMetadata<PackLineRead>(symbols.entity, {
    packedQuantity: Number,
    status: String,
    packingListDate: String,
    projectLineId: String,
    packLineValue: CurrencySymbol,
    lineNumber: Number,
    packingListId: String,
    bundle: Object,
    projectLineItem: Object,
    customFields: [CustomFieldMetadataMap.symbols.entity],
    weight: Object,
    dimensions: Object,
});

withMetadata<PackLineCreate>(symbols.createBody, {
    dimensions: Object,
    inventoryBundleId: String,
    packLineValue: CurrencySymbol,
    packedQuantity: Number,
    packingListDate: String,
    projectLineId: String,
    lineNumber: Number,
    salesOrder: String,
    status: String,
    weight: Object,
});

withDefaultSearchParamsMetadata<PackLineSearchParams>(symbols.searchParams, {
    projectId: String,
    status: [String],
    inventoryBundleId: String,
    itemId: String,
});

export const PackLineMetadataMap: IMappingProfile = {
    symbols,
    profile: (mapper: Mapper) => {
        createMap<PackLineRead, PackLineDto>(
            mapper,
            symbols.entity,
            symbols.dto
        );
        createMap<PackLineDto, PackLineRead>(
            mapper,
            symbols.dto,
            symbols.entity
        );
        createMap<PackLineDto, PackLineCreate>(
            mapper,
            symbols.dto,
            symbols.createBody,
            forMember(
                d => d.projectLineId,
                mapFrom(s => s.projectLineItem?.id)
            ),
            forMember(
                d => d.inventoryBundleId,
                mapFrom(s => s.bundle?.id)
            )
        );
        createMap<IQueryParams<PackLineDto>, PackLineSearchParams>(
            mapper,
            IQueryParamsSymbol,
            symbols.searchParams,
            withArraySearchFilter('status'),
            withFragmentSearchFilter('projectLineId'),
            forMember(
                d => d.inventoryBundleId,
                mapFrom(s => {
                    if (s.searchStrategy && s.searchStrategy >= 0) {
                        return null;
                    }
                    return s.filters?.bundle;
                })
            ),
            withSearchFilterUnTyped('itemId')
        );
    },
};
